import { getCookie } from './util/cookies';

const includeUrls = [
    'stest.if.dk/privat',
    'atest.if.dk/privat',
    'da.stest.mypages.ifext.biz',
    'da.internal.stest.mypages.ifext.biz',
    'atest.minesider.if.dk',
    'da.internal.atest.mypages.ifext.biz',
    '#ifgpt',
];

const excludeUrls = ['.if.dk/privat/anmeld-skade/koeretoejer/viking-chat', '#contactpanel'];

const findIncludeUrl = (): string | undefined => {
    const href = window.location.href;
    return includeUrls.find((url) => href.includes(url));
};

const findExcludeUrl = (): string | undefined => {
    const href = window.location.href;
    return excludeUrls.find((url) => href.includes(url));
};

const getSubDomain = (): string => {
    const hostname = window.location.hostname;
    if (!hostname.includes('test') && hostname.includes('.if.dk')) return 'www';
    return hostname.includes('atest') ? 'atest' : 'stest';
};

const isIfMobile = (): boolean => /If Mobile/.test(window.navigator.userAgent);
const isPuzzelChatActive = (): boolean => getCookie('psCurrentState') === 'InDialog';
const isIfGPTChatActive = (): boolean => !!getCookie('ifgpt-session');

export const showIfGPT = (ifMobileToggle: boolean): boolean => {
    if (isIfMobile() && !ifMobileToggle) return false;
    if (isPuzzelChatActive()) return false;
    if (!isIfGPTChatActive() && !findIncludeUrl()) return false;
    if (findExcludeUrl()) return false;

    const client = document.createElement('ifgpt-web-client');
    document.body.appendChild(client);

    const subDomain = getSubDomain();
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://${subDomain}.if.dk/apps/ifgpt/assets/ifgpt-web-client.js`;
    script.id = 'ifgpt';
    script.async = true;
    document.body.appendChild(script);

    return true;
};
